var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.technologies.cms)?_c('div',{staticClass:"flex cursor-pointer justify-center items-center h-full"},[(_vm.technologies.cms.name)?_c('img',{staticStyle:{"width":"25px","height":"25px"},attrs:{"src":_vm.getImagePath(_vm.technologies.cms.code.toLowerCase()),"alt":"graphic-404"}}):_vm._e()]):_c('div',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }